import type { RenditionSize } from '@shared/utils/photoRendition';

/**
 * Single source of truth for guest site photo rendition sizes.
 * Used by both OptimizedEventGuestSitePhoto (runtime) and PreloadImages (SSR).
 *
 * LOW_RES is preloaded during SSR and rendered immediately.
 * HIGH_RES is loaded in the background after hydration, then crossfaded in.
 */
export const LOW_RES_RENDITION: RenditionSize = 'tiny';
export const HIGH_RES_RENDITION: RenditionSize = 'xlarge';
